import { render, staticRenderFns } from "./LoadingForum.vue?vue&type=template&id=78740558&scoped=true&"
import script from "./LoadingForum.vue?vue&type=script&lang=js&"
export * from "./LoadingForum.vue?vue&type=script&lang=js&"
import style0 from "./LoadingForum.vue?vue&type=style&index=0&id=78740558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78740558",
  null
  
)

export default component.exports